'use strict';

// import MpModal from '../../modules/components/modal';

// Add init function that is executed on every page/fragment render
mpro.addInitStatic(($container) => {

	// const $collection = $container.find('div[class^="bslot"][data-href]');

	// $collection.each(function () {
	// 	$(this).on('click', function (e) {
	// 		if (e.target.nodeName != 'A' && e.target.nodeName != 'BUTTON') {

	// 			// e.preventDefault();
	// 			// e.stopImmediatePropagation();
	// 			// e.stopPropagation();

	// 			// const $parentModal = $(this).closest('.modal');
	// 			// if ($parentModal && $parentModal.is('[data-bs-dismiss-actions]') ) {
	// 			// 	MpModal.getOrCreateInstance(this).close();
	// 			// 	console.log(MpModal.getOrCreateInstance(this));
	// 			// }

	// 			if (this.dataset.target === '_blank') {
	// 				mpro.openLinkInNewWindow(this.dataset.href);
	// 			}
	// 			else {
	// 				// Do redirect in ajax-navigation or fallback on window.location
	// 				mpro.setLocation(this.dataset.href);
	// 			}
	// 		}
	// 	});
	// });

	const { click_selector, submit_selector } = mpro.config.rules.overlays.navigation;
	const $links = $container.find('.modal-body .bslot-html ' + click_selector)
		.add($container.find('.modal-body .bslot-newsletter ' + click_selector))
		.add($container.find('.modal-body .bslot-age-verification ' + click_selector));

	$links.off('.overlay-navigation').on('click', function (e) {
		if (e.currentTarget.href) {
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();
			mpro.openLinkInNewWindow(e.currentTarget.href);
		}
	});
});
